<!--suppress ALL -->
<template>
  <div :class="controlClassName">
    <div :class="selectWrapperClassName">
      <select :class="className" :size="nativeSize" :multiple="isMultiple" v-bind="$attrs"
              @focus="onFocus" @blur="onBlur" v-model="newValue" @change="onChange">
        <template v-if="placeholder && !newValue">
          <option selected disabled hidden :value="placeholderValue">
            {{ placeholder }}
          </option>
        </template>
        <slot></slot>
      </select>
    </div>
    <span v-if="$slots.iconLeft" :class="`icon is-left ${size ? ('is-'+size) : ''}`">
            <slot name="iconLeft"></slot>
        </span>
  </div>
</template>

<script lang="ts">
  import {Component, Prop, Mixin, Watch} from 'annotation';
  import FormPropMixins from '../../../../util/mixin/FormProperties';

  @Component
  export default class GSelect extends Mixin(FormPropMixins) {

    @Prop({default: '', type: String})
    public label: string;

    @Prop({default: '', type: String})
    public message: string;

    @Prop({default: false, type: Boolean})
    public isStatic: boolean;

    @Prop({default: false, type: Boolean})
    public isFullwidth: boolean;

    @Prop()
    public isMultiple: boolean;

    @Prop()
    public nativeSize: any;

    @Prop({default: '', type: String})
    public placeholder: string;

    @Prop({default: null})
    public value: any;

    public placeholderValue: any;

    @Watch('value', {immediate: true})
    public onValueChange(value) {
      this.selected = value;

      // for placeholder so can appear as the default selected value
      // if the value is null, '', undefined, 0
      if (!value) {
        this.placeholderValue = value;
      }
    }

    /**
     * Force sync native <select> DOM element with reactive state.
     * Fixes Vue 2 issue where v-model on <select> loses sync
     * when slot children (option elements) are patched/recreated.
     */
    public updated() {
      this.$nextTick(() => {
        const selectEl = this.$el?.querySelector('select') as HTMLSelectElement;
        if (selectEl && this.selected != null && selectEl.value !== String(this.selected)) {
          selectEl.value = String(this.selected);
        }
      });
    }

    public selected: any = this.value;

    public get newValue() {
      return this.selected;
    }

    public set newValue(value) {
      this.selected = value;
      this.$emit('input', value);
    }

    public get alterClassName() {
      if (this.$parent.isFieldComponent) {
        const {type, size} = this.$parent;
        return [type, size].reduce((accu, item) => accu + (item ? ` is-${item}` : ''), '');
      }

      return '';
    }

    public get className() {
      const {isFocused}: any = this;

      return [{'is-focused': isFocused}];
    }

    public get controlClassName() {
      const {$slots, isExpanded} = this;

      return [{'has-icons-left': $slots.iconLeft, 'is-expanded': isExpanded}, 'g-select control']
    }

    public get selectWrapperClassName() {
      const {isLoading, type, size, shape, isMultiple, alterClassName, isFullwidth} = this;
      const finalClassName = [type, size, shape].reduce((accu, item) => accu + (item ? `is-${item} ` : ''), '');

      return ['select', finalClassName, alterClassName, {
        'is-loading': isLoading, 'is-multiple': isMultiple, 'is-fullwidth': isFullwidth
      }];
    }

    public onChange(e) {
      this.$emit('change', e && e.target && e.target.value);
    }
  }
</script>
